import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetContactUslisting, setGetPartnerListData } from "../booking/bookingSlice";


export const getContactusListingData = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get("admin/settings/contact-inquiries", { params: data });
      console.log(response,"response")
      if (response?.data) {
        dispatch(setGetContactUslisting(response?.data?.response))
      } else {
        dispatch(setGetContactUslisting([]))
      }
    } catch (err) {
      // console.error(err);
      dispatch(setGetContactUslisting([]))
    }
  };

  export const updateContactusStatus = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.put("admin/settings/contact-inquiries", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
       
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      // console.error(err);
    } finally {
    }
  };